import { atom } from "recoil";

export const roomConfigAtom = atom<any>({
  key: "roomConfigAtom",
  default: {},
});
